import { create } from 'zustand';

// Define the state and actions types
type ContractStoreState = {
  shouldShowContract: boolean | undefined;
  setShouldShowContract: (shouldshow: boolean) => void;
};

// Create the store with default value from cookies
const useContractStore = create<ContractStoreState>((set) => ({
  shouldShowContract: undefined,
  setShouldShowContract: (shouldshow) => {
    set({ shouldShowContract: shouldshow });
  },
}));

export { useContractStore };
